module.exports = __webpack_public_path__ + "img/anewitem-real-estate.c214a11e.svg";